import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../api.js'
import { useAuth } from '../auth/AuthContext.jsx'

// Admin: category create/rename — a standalone page (project rule: every
// form is its own page). With :id → edit, without → create.

export function AdminCategoryFormPage() {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()
  const { user, loading: authLoading } = useAuth()
  const isEdit = Boolean(id)

  const [name, setName] = useState('')
  const [loading, setLoading] = useState(isEdit)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (authLoading || !user || user.role !== 'admin' || !isEdit) return
    api.admin.categories.list()
      .then((d) => {
        const cat = (d.categories || []).find((c) => String(c.id) === String(id))
        if (!cat) { setError('not_found'); return }
        setName(cat.name)
      })
      .catch((e) => setError(e.code || 'server'))
      .finally(() => setLoading(false))
  }, [authLoading, user, id, isEdit])

  async function submit(e) {
    e.preventDefault()
    setBusy(true); setError(null)
    try {
      if (isEdit) await api.admin.categories.update(id, { name: name.trim() })
      else        await api.admin.categories.create({ name: name.trim() })
      navigate('/admin/categories', { replace: true })
    } catch (err) {
      setError(err.code || 'server')
      setBusy(false)
    }
  }

  if (authLoading || loading) return <main className="container"><p>{t('common.loading')}</p></main>
  if (!user || user.role !== 'admin') {
    return <main className="container"><p className="error">{t('admin.errors.not_admin')}</p></main>
  }

  return (
    <main className="container">
      <p><Link to="/admin/categories">← {t('admin_categories.title')}</Link></p>
      <h1>{isEdit ? t('admin_categories.edit_title') : t('admin_categories.add_title')}</h1>

      {error && <p className="error">{t(`admin_categories.errors.${error}`, { defaultValue: error })}</p>}

      <section className="card form-card">
        <form onSubmit={submit} noValidate>
          <label>
            <span>{t('admin_categories.form_name')}</span>
            <input value={name} onChange={(e) => setName(e.target.value)} required minLength={2} />
          </label>
          <div className="form-actions">
            <button type="submit" disabled={busy}>{busy ? t('common.loading') : t('common.save')}</button>
            <Link to="/admin/categories" className="link-button">{t('common.cancel')}</Link>
          </div>
        </form>
      </section>
    </main>
  )
}
